import { Typography } from '@mui/material';
import {
  Datagrid,
  DateField,
  ListContextProvider,
  ResourceContextProvider,
  TextField,
  useGetMany,
  useGetManyReference,
  useList,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { Contract } from '../types';
import InvoicePdfButton from './InvoicePdfButton';
import { Divider, Box } from '@mui/material';
import CreditMemoButton from './CreditMemoButton';
import LinkToQbButton from './LinkToQbButton';

const ContractLinkedInvoicesList = () => {
  const translate = useTranslate();
  const record = useRecordContext<Contract>();

  const { data: supabaseInvoices } = useGetManyReference(
    'sb_invoices',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: qbInvoicesData, isLoading: isInvoicesLoading } = useGetMany(
    'invoices',
    {
      ids: supabaseInvoices
        ? supabaseInvoices.map((invoice) => invoice.accounting_reference_id)
        : [],
    },
    { enabled: supabaseInvoices && supabaseInvoices.length > 0 }
  );
  const invoices = qbInvoicesData ? qbInvoicesData : [];


  const listContext = useList({ data: invoices });
  if (isInvoicesLoading) return null;
  
  return (
    <Box my={4}>
      <Typography variant='h6'>
        {translate('resources.invoices.name', { smart_count: invoices.length })}
      </Typography>
      <Divider />
      { invoices.length == 0 ? 
          <Typography mt={1}>No invoices</Typography>
         :
      <ResourceContextProvider value="invoices">
        <ListContextProvider value={listContext}>
          <Datagrid bulkActionButtons={false}>
            <TextField source="DocNumber" />
            <DateField source="DueDate" />
            <DateField source="TxnDate" />
            <QuickbooksPriceField source="TotalAmt" />
            <QuickbooksPriceField source="Balance" />
            {/* <TextField source="PrintStatus" /> */}
            {/* <TextField source="EmailStatus" /> */}
            <InvoicePdfButton source="id" label="Print EN" locale="en"/>
            <InvoicePdfButton source="id" label="Print FR" locale="fr" />
            <LinkToQbButton label="View in QB" type='invoice'/>
          </Datagrid>
        </ListContextProvider>
      </ResourceContextProvider>
    }
    </Box>
  );
};

export default ContractLinkedInvoicesList;
